jQuery(document).ready(function($){
	$('.productgroup-toggle').on('click', function(e) {
		$(this).addClass('active');
		$(this).siblings().removeClass('active');
		var group = $(this).data('group');
		$(this).parent().parent().parent('.align-center').siblings('.product-group').each(function(){
			$(this).addClass('hide');
			if ($(this).data('group') == group) {
				$(this).removeClass('hide');
				$(this).foundation('_reflow'); // reinit foundation equalizer
				const cards = $(this).children();
		    	gsap.fromTo(cards, 
		    		{
			    		opacity: 0,
			    		scale: .8,
			    		x: -50,
		    		},
		    		{
			    		opacity: 1,
			    		scale: 1,
			    		x: 0,
			    		duration: 1,
			    		ease: "power2.out",
			    		stagger: {
			    			each: 0.1,
			    		},
			    	}
			    );
			}
		});
	});

	// Off canvas triggers
	$('.off-canvas').on('opened.zf.offcanvas', function(event) {
		$('#menu_icon').addClass('hide');
		$('#close_icon').removeClass('hide');
	});
	$('.off-canvas').on('closed.zf.offcanvas', function(event) {
		$('#close_icon').addClass('hide');
		$('#menu_icon').removeClass('hide');
	});

	 gsap.registerPlugin(ScrollTrigger);

	 $('.number_counter_item_title').each(function() {
        const odometerElement = $(this);
        const targetValue = parseFloat(odometerElement.data('number-base')); 
        
        gsap.to({value: 0}, {
            value: targetValue, 
            duration: 4, 
            ease: "power2.out",
           // scrollTrigger: {
           //     trigger: odometerElement[0], 
           //     start: "top 80%", 
           //     end: "bottom 20%", 
           // },
            onUpdate: function() {
                let formattedValue = this.targets()[0].value.toLocaleString(undefined, { maximumFractionDigits: 2 });
                odometerElement.find('.js_number_countup').text(formattedValue); 
            }
        });
    });

    $('.number_counter_stats_item_title').each(function() {
        const odometerElement = $(this);
        const targetValue = parseFloat(odometerElement.data('number-base')); 
        
        gsap.to({value: 0}, {
            value: targetValue, 
            duration: 3, 
            ease: "power2.out",
            scrollTrigger: {
                trigger: odometerElement[0], 
                start: "top 80%", 
                end: "bottom 20%", 
            },
            onUpdate: function() {
                let formattedValue = this.targets()[0].value.toLocaleString(undefined, { maximumFractionDigits: 0 });
                odometerElement.find('.js_number_countup').text(formattedValue); 
            }
        });
    });

    

    $('.product-group').each(function() {
    	let tl = gsap.timeline();
    	const group = $(this);
    	const cards = group.children();
    	gsap.fromTo(cards, 
    		{
	    		opacity: 0,
	    		scale: .8,
	    		x: -50,
    		},
    		{
	    		opacity: 1,
	    		scale: 1,
	    		x: 0,
	    		duration: 1,
	    		ease: "power2.out",
	    		stagger: {
	    			each: 0.1,
	    		},
	    		scrollTrigger: {
	                trigger: group, 
	                start: "top 80%", 
	                end: "bottom 20%", 
	            },
	    	}
	    )
    	// for (var i = cards.length - 1; i >= 0; i--) {
    	// 	tl.to(cards[i], { 
    	// 		opacity: 1, 
    	// 		duration: 2,
    	// 		scale: 0.2
    	// 		// scrollTrigger: {
	    //         //     trigger: cards[i], 
	    //         //     start: "top 80%", 
	    //         //     end: "bottom 20%", 
	    //         // },
    	// 	});
    	// }
    })


});